// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__27tep","productName":"Table_productName__11fX1"};